export class Origem{
    id;
    descricao: string;
    ativo: string;
    dataCadastro: string;
    reqExterna: string;
    idEmpresa: number;
}